<script setup lang="ts">
import { computed } from 'vue'

interface SubjectItem {
  name: string
  image: string
  description: string
}

const { physicsImageUrl, chemistryImageUrl, biologyImageUrl, scienceImageUrl } = defineProps<{
  physicsImageUrl: string
  chemistryImageUrl: string
  biologyImageUrl: string
  scienceImageUrl: string
}>()

const subjects = computed<SubjectItem[]>(() => [
  {
    name: '物理',
    image: physicsImageUrl,
    description: '光学 · 力学 · 电学',
  },
  {
    name: '化学',
    image: chemistryImageUrl,
    description: '物质结构 · 化学反应',
  },
  {
    name: '生物',
    image: biologyImageUrl,
    description: '生命结构 · 生长与环境',
  },
  {
    name: '科学',
    image: scienceImageUrl,
    description: '跨学科现象 · 科学探究',
  },
])
</script>

<template>
  <section id="subjects" class="subjects section">
    <div class="container">
      <div class="section-heading centered">
        <h2>覆盖小初高核心学科</h2>
        <p>物理、化学、生物与科学虚拟实验，与小学、初中、高中教材章节同步。</p>
      </div>

      <div class="subject-grid">
        <article
          v-for="(subject, index) in subjects"
          :key="subject.name"
          class="subject-item"
          :class="`subject-motion-${index}`"
          tabindex="0"
        >
          <div class="subject-image">
            <img
              v-if="subject.image"
              :src="subject.image"
              :alt="`${subject.name}实验`"
              loading="lazy"
            />
            <div v-else class="image-placeholder">{{ subject.name }}学科图</div>
            <span class="subject-light" aria-hidden="true"></span>
          </div>
          <h3>{{ subject.name }}</h3>
          <p>{{ subject.description }}</p>
        </article>
      </div>
    </div>
  </section>
</template>
